var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name2 in all)
    __defProp(target, name2, { get: all[name2], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => stdin_default
});
var import_vue = __toModule(require("vue"));
var import_vue2 = __toModule(require("vue"));
var import_utils = __toModule(require("../utils"));
var import_use_lazy_render = __toModule(require("../composables/use-lazy-render"));
const [name, bem] = (0, import_utils.createNamespace)("overlay");
const overlayProps = {
  show: Boolean,
  zIndex: import_utils.numericProp,
  duration: import_utils.numericProp,
  className: import_utils.unknownProp,
  lockScroll: import_utils.truthProp,
  lazyRender: import_utils.truthProp,
  customStyle: Object
};
var stdin_default = (0, import_vue2.defineComponent)({
  name,
  props: overlayProps,
  setup(props, {
    slots
  }) {
    const lazyRender = (0, import_use_lazy_render.useLazyRender)(() => props.show || !props.lazyRender);
    const preventTouchMove = (event) => {
      (0, import_utils.preventDefault)(event, true);
    };
    const renderOverlay = lazyRender(() => {
      var _a;
      const style = (0, import_utils.extend)((0, import_utils.getZIndexStyle)(props.zIndex), props.customStyle);
      if ((0, import_utils.isDef)(props.duration)) {
        style.animationDuration = `${props.duration}s`;
      }
      return (0, import_vue.withDirectives)((0, import_vue.createVNode)("div", {
        "style": style,
        "class": [bem(), props.className],
        "onTouchmove": props.lockScroll ? preventTouchMove : import_utils.noop
      }, [(_a = slots.default) == null ? void 0 : _a.call(slots)]), [[import_vue.vShow, props.show]]);
    });
    return () => (0, import_vue.createVNode)(import_vue2.Transition, {
      "name": "van-fade",
      "appear": true
    }, {
      default: renderOverlay
    });
  }
});
